// import { getTrainerSounds } from '@/helpers/constants'
import { v4 as uuid } from 'uuid'

import sound_action_check from '@/store/sounds/sounds_assets/sound_action_check.mp3'
import sound_action_fold from '@/store/sounds/sounds_assets/sound_action_fold.mp3'
import sound_chips_to_pot from '@/store/sounds/sounds_assets/sound_chips_to_pot.mp3'
import sound_chips_to_table from '@/store/sounds/sounds_assets/sound_chips_to_table.mp3'
import sound_deal_card from '@/store/sounds/sounds_assets/sound_deal_card.mp3'
// import sound_timebank_3s from '@/store/sounds/sounds_assets/sound_timebank_3s.mp3'
import sound_timebank_5s from '@/store/sounds/sounds_assets/sound_timebank_5s.mp3'
import sound_winstreak_prompt from '@/store/sounds/sounds_assets/sound_winstreak_prompt.mp3'
// import sound_winstreak_prompt2 from '@/store/sounds/sounds_assets/sound_winstreak_prompt2.mp3'
// import sound_volume from '@/store/sounds/sounds_assets/sound_volume.mp3'
import sound_volume2 from '@/store/sounds/sounds_assets/sound_volume2.mp3'

function getTrainerSounds() {
  return {
    sound_action_check,
    sound_action_fold,
    sound_chips_to_pot,
    sound_chips_to_table,
    sound_deal_card,
    sound_timebank_3s: sound_timebank_5s,
    // sound_timebank_5s,
    sound_timebank_5s,
    sound_winstreak_prompt,
    // sound_winstreak_prompt:sound_winstreak_prompt2,
    // sound_winstreak_prompt,
    // sound_volume,
    sound_volume: sound_volume2,
  }
}

const getInitialState = () => {
  const volumeMuted = localStorage.getItem('sound_muted')
  let volume = localStorage.getItem('sound_volume')
  // volume = volume ? Number(volume) : 0.6
  volume = volume ? Number(volume) : 0
  return {
    sounds_muted: volume === 0 || volumeMuted === 'true',
    sounds_volume: volume,
  }
}

const currentAudios = {}
function unregisterAudio(e) {
  if (!e?.path?.[0]) return
  const audio = e.path[0]
  const audioId = audio.id
  audio.removeEventListener('ended', unregisterAudio)
  delete currentAudios[audioId]
  // console.log(currentAudios)
}
function setVolumeToAudios(state) {
  Object.keys(currentAudios).forEach(key => {
    const audio = currentAudios[key]
    audio.volume = state.sounds_muted ? 0 : state.sounds_volume
    // console.log(audio.volume)
  })
}

const getters = {
  sounds_volume: state => state.sounds_volume,
  sounds_muted: state => state.sounds_muted,
}

const actions = {
  sounds_play({ state, getters, rootGetters, commit, dispatch }, sound = 'action_call.mp3') {
    if (state.sounds_muted) return

    const file = getTrainerSounds()[sound]
    if (!file) {
      console.warn('No such sound:', file)
      return
    }

    try {
      // user must interact with the page before audio can be played - sentryEx01 exeption in sentry
      // sound must be triggered synchronously (so no vue watchers, no async/await, no setTimeout)
      // safari audio bug
      // await new Promise((r) => setTimeout(r, 2000))
      // https://arrangeactassert.com/posts/how-to-fix-the-request-is-not-allowed-by-the-user-agent-or-the-platform-in-the-current-context-possibly-because-the-user-denied-permission/
      // Unhandled Promise Rejection: NotAllowedError: The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.

      const audio = new Audio(file)

      audio.id = uuid()
      audio.volume = state.sounds_volume
      // audio.playsinline = true
      audio.play()
      audio.addEventListener('ended', unregisterAudio)
      currentAudios[audio.id] = audio
    } catch (error) {
      console.warn('ERROR sounds', sound)
    }
  },
  sounds_play_action({ state, getters, commit, dispatch }, { action }) {
    if (!action) return
    let sound = ''
    if (['RAISE', 'CALL'].includes(action.type)) {
      sound = `sound_chips_to_table`
    } else {
      sound = `sound_action_${action.type.toLowerCase()}`
    }
    dispatch('sounds_play', sound)
  },
}

const mutations = {
  sounds_set_volume(state, v) {
    state.sounds_volume = v
    setVolumeToAudios(state)
  },
  sounds_set_muted(state, v) {
    state.sounds_muted = v
    setVolumeToAudios(state)
  },
}

function getSoundsModule(namespace) {
  return {
    state: getInitialState({ namespace }),
    getters,
    actions,
    mutations,
  }
}
export { getSoundsModule }
